import { User } from '../types/tournament';
import { getDisplayName } from './userDisplayName';

export const imgOptionUserLabel = (user: User) => ({
    value: user.id,
    label: getDisplayName(user),
    avatar: user.avatar,
});
